// reducers/authReducer.js
const initialState = {
    isLoggedIn: false,
    userName: null
};

const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'LOGIN':
            return { ...state, isLoggedIn: true };
        case 'LOGOUT':
            return { ...state, isLoggedIn: false };
        case 'POPULATE_STATE':
            // Update the state with the authentication data
            return {
                ...state,
                isLoggedIn: action.payload.isAuthenticated,
                userName: action.payload.userName,
                // Other fields you want to update
            };
        default:
            return state;
    }
};

export default authReducer;
